export default __webpack_public_path__ + "img/Rhone.b86b66af.png";